// !!!! - DO NOT MODIFY - !!!!
// THIS FILE IS DEPLOYED AUTOMATICALLY BY MATTv2.
//
//  Deployment info:
//    Updated at:     2025-12-11T11:33:46+00:00
//    Cause:          Manual deployment.
//    Deployment ID:  190785
//    Project:        617
//    Environment:    7626 - master
//    MD5:            aed460924112c39906e0865e5759f7d8
//    Signature:      eyJpdiI6Ijc0UGhobVhTVjJONFRWWUtBMlZOdFE9PSIsInZhbHVlIjoiUjNXbytDQVNOM09ZQXF4Z0ROYUpHMzlDZ2Q1OG5MdEZGQVhjaVV6R2Q4U25uczAxM3U2VFwvVzM0UnpqTllDb1JKSU9vTk03Mjh0ZHM4bXV6UldPRHFRU0Y4ZWJlTk1sdDYreUdEZTR5MmJmNjl1ZnhrRXFMdGRkTjcwRTd4NlpmNnliNFZ5aVVhdHpEV3d1WHMraDVZVnc5SjVnYVZxUjVDQzgwekhxa3U2WWRtRWhUQWZrNXNjZ3h1RzRIcmo5TkptNkNkTWVPZ2VPVDhPMlhiYXdzYll2QW5LYUFMQUZ1Um5PY3lXckdJbGtBeDd4M3FlWXB6dngzSDlWelF6WVIwKzdXVkdEY3dNK3RYSmt6WmVGNVBQcU82QW9vODVyS0hqYW1SQzJEQnVxSjR6NkRBZm1FaGlRcUpGQkV0STFVMEZOVURvemQ2VmZCZ05LeTdSR3lQbzZcL1pEQmlGNldGNWRIUUpQUTI1bzdFaUZTV2M2N3V2ZHNoUERxS1JIODV3N3cyZndDRTl5UHF2ZHBhNWZTWk53OGtNemVoaHA0WFp6dTBXRG05bTZnPSIsIm1hYyI6IjMwZTdlZmFlZDc0ZDQyZjc2NDk3ZTA4Nzc2NmY4MTk1OTE2YmQzM2U4MDZmZWEyZjgxZjRlY2VhNmM0YTQxZGUifQ==
((document, window) => {
    const okeRenderedHandler = function (e) {
        if (e.detail.widget === 'reviews-widget') {
            setupCollectionDropdownControls();
        }
    }

    document.addEventListener('oke-rendered', okeRenderedHandler);

    if (!String.prototype.startsWith) {
        Object.defineProperty(String.prototype, 'startsWith', {
            value: function (search, rawPos) {
                var pos = rawPos > 0 ? rawPos | 0 : 0;
                return this.substring(pos, pos + search.length) === search;
            }
        });
    }

    function i(e, t) {
        var n;
        if ('undefined' == typeof Symbol || null == e[Symbol.iterator]) {
            if (
                Array.isArray(e) ||
                (n = (function (e, t) {
                    if (!e) return;
                    if ('string' == typeof e) return o(e, t);
                    var n = Object.prototype.toString.call(e).slice(8, -1);
                    'Object' === n && e.constructor && (n = e.constructor.name);
                    if ('Map' === n || 'Set' === n) return Array.from(e);
                    if ('Arguments' === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return o(e, t);
                })(e)) ||
                (t && e && 'number' == typeof e.length)
            ) {
                n && (e = n);
                var i = 0,
                    r = function () { };
                return {
                    s: r,
                    n: function () {
                        return i >= e.length ? { done: !0 } : { done: !1, value: e[i++] };
                    },
                    e: function (e) {
                        throw e;
                    },
                    f: r,
                };
            }
            throw new TypeError('Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.');
        }
        var a,
            s = !0,
            c = !1;
        return {
            s: function () {
                n = e[Symbol.iterator]();
            },
            n: function () {
                var e = n.next();
                return (s = e.done), e;
            },
            e: function (e) {
                (c = !0), (a = e);
            },
            f: function () {
                try {
                    s || null == n.return || n.return();
                } finally {
                    if (c) throw a;
                }
            },
        };
    }

    function toggleVisibility(e) {
        var t,
            n = i(e);
        try {
            for (n.s(); !(t = n.n()).done;) {
                t.value.classList.toggle('is-visible');
            }
        } catch (e) {
            n.e(e);
        } finally {
            n.f();
        }
    }

    function setupCollectionDropdownControls() {
        var navbarMale = document.querySelector('.orc-radioControl-navbar-item.js-orc--male');
        var navbarFemale = document.querySelector('.orc-radioControl-navbar-item.js-orc--female');
        var maleSelectList = document.querySelector('.orc-collectionControls-item--male');
        var femaleSelectList = document.querySelector('.orc-collectionControls-item--female');
        var reviewsWidgetElement = document.querySelector('#orc-widget-snippet');

        attachNavbarClickEvents(navbarMale, maleSelectList, navbarFemale, femaleSelectList, reviewsWidgetElement);

        var femaleCollectionDropdownList = document.querySelector('.js-orc-collectionDropdown.js-orc--female');
        document.querySelectorAll('.orc-collectionControls-item--female .orc-collectionDropdown-item'),
            femaleCollectionDropdownList.addEventListener('click', function () {
                toggleVisibility(femaleCollectionDropdownListItems), femaleCollectionDropdownList.classList.toggle('active');
            });
        
        var maleCollectionDropdownList = document.querySelector('.js-orc-collectionDropdown.js-orc--male');
        var maleCollectionDropdownListItem = document.querySelectorAll('.orc-collectionControls-item--male .orc-collectionDropdown-item');
        
        maleCollectionDropdownList.addEventListener('click', function () {
            toggleVisibility(maleCollectionDropdownListItem), maleCollectionDropdownList.classList.toggle('active');
        });

        var u,
            femaleCollectionDropdownListItems = Array.prototype.slice.call(document.querySelectorAll('.orc-collectionControls-item--female .orc-collectionDropdown-item')),
            h = i(femaleCollectionDropdownListItems);
        try {
            var f = function () {
                var e = u.value;
                e.addEventListener('click', function () {
                    if (!e.getAttribute('value')) {
                        snippetEl.removeAttribute('data-oke-reviews-group-id');
                        snippetEl.removeAttribute('data-oke-reviews-product-id');
                        snippetEl.innerHTML = '';
                        window.okeWidgetApi.initWidget(snippetEl, true);
                        return;
                    }

                    window.okeWidgetApi.setGroup(reviewsWidgetElement, e.getAttribute('value'));

                    toggleVisibility(femaleCollectionDropdownListItems);
                    (femaleCollectionDropdownList.innerHTML = e.innerHTML);
                    femaleCollectionDropdownList.setAttribute('data-displayed', e.innerHTML);
                    if (femaleCollectionDropdownList.classList.contains('active')) {
                        femaleCollectionDropdownList.classList.remove('active');
                    }
                });
            };
            for (h.s(); !(u = h.n()).done;) f();
        } catch (e) {
            h.e(e);
        } finally {
            h.f();
        }
        var m,
            p = Array.prototype.slice.call(document.querySelectorAll('.orc-collectionControls-item--male .orc-collectionDropdown-item')),
            v = i(p);
        try {
            var y = function () {
                var e = m.value;
                e.addEventListener('click', function () {
                    if (!e.getAttribute('value')) {
                        snippetEl.removeAttribute('data-oke-reviews-group-id');
                        snippetEl.removeAttribute('data-oke-reviews-product-id');
                        snippetEl.innerHTML = '';
                        window.okeWidgetApi.initWidget(snippetEl, true);
                        return;
                    }

                    window.okeWidgetApi.setGroup(reviewsWidgetElement, e.getAttribute('value'))
                    toggleVisibility(p);
                    (maleCollectionDropdownList.innerHTML = e.innerHTML);
                    maleCollectionDropdownList.setAttribute('data-displayed', e.innerHTML);

                    if (maleCollectionDropdownList.classList.contains('active')) {
                        maleCollectionDropdownList.classList.remove('active');
                    }
                });
            };
            for (v.s(); !(m = v.n()).done;) y();
        } catch (e) {
            v.e(e);
        } finally {
            v.f();
        }

        document.removeEventListener('oke-rendered', okeRenderedHandler);
    }

    function attachNavbarClickEvents(navbarMale, maleSelectList, navbarFemale, femaleSelectList, reviewsWidgetElement) {
        navbarMale.addEventListener('click', function () {
            (navbarMale.classList.contains('is-active') && !t.classList.contains('is-active')) ||
                (navbarMale.classList.toggle('is-active'),
                    maleSelectList.classList.toggle('is-active'),
                    navbarFemale.classList.remove('is-active'),
                    femaleSelectList.classList.remove('is-active'),
                    navbarMale.classList.contains('is-active') && window.okeWidgetApi.setGroup(reviewsWidgetElement, 'a5a04748-c618-46c0-bbfa-45c922a23215'));
        });

        navbarFemale.addEventListener('click', function () {
            (navbarFemale.classList.contains('is-active') && !navbarMale.classList.contains('is-active')) ||
                (navbarFemale.classList.toggle('is-active'),
                    femaleSelectList.classList.toggle('is-active'),
                    navbarMale.classList.remove('is-active'),
                    maleSelectList.classList.remove('is-active'),
                    navbarFemale.classList.contains('is-active') && window.okeWidgetApi.setGroup(reviewsWidgetElement, 'b38aa450-ab71-4233-a611-ca17a66a3bc5'));
        });
    }
})(document, window);